import { NavigationSortOrder, NavigationType } from '../models';
export var DynamicNavigationFieldNames;
(function (DynamicNavigationFieldNames) {
    DynamicNavigationFieldNames["MultiSelect"] = "multiSelect";
    DynamicNavigationFieldNames["Name"] = "name";
    DynamicNavigationFieldNames["Tags"] = "tagList";
    DynamicNavigationFieldNames["Field"] = "field";
    DynamicNavigationFieldNames["Sort"] = "sort";
    DynamicNavigationFieldNames["Type"] = "type";
    DynamicNavigationFieldNames["Range"] = "ranges";
    DynamicNavigationFieldNames["CreatedByEmail"] = "createdByEmail";
    DynamicNavigationFieldNames["ModifiedByEmail"] = "modifiedByEmail";
    DynamicNavigationFieldNames["Metadata"] = "metadata";
    DynamicNavigationFieldNames["pinnedRefinements"] = "pinnedRefinements";
})(DynamicNavigationFieldNames || (DynamicNavigationFieldNames = {}));
export const SORT_ORDER_OPTIONS = [
    { value: NavigationSortOrder.CountDescending, label: 'COUNT_DESCENDING' },
    { value: NavigationSortOrder.ValueAscending, label: 'VALUE_ASCENDING' },
    { value: NavigationSortOrder.ValueDescending, label: 'VALUE_DESCENDING' },
];
export const DEFAULT_SORT_ORDER = NavigationSortOrder.ValueAscending;
export const defaultFormValues = {
    [DynamicNavigationFieldNames.MultiSelect]: false,
    [DynamicNavigationFieldNames.Name]: '',
    [DynamicNavigationFieldNames.Tags]: [],
    [DynamicNavigationFieldNames.Field]: '',
    [DynamicNavigationFieldNames.Sort]: undefined,
    [DynamicNavigationFieldNames.Type]: NavigationType.Value,
    [DynamicNavigationFieldNames.Range]: undefined,
    [DynamicNavigationFieldNames.pinnedRefinements]: [],
};
